import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { getVisiblePages } from "../utils/pagination";

const PaginationControls = ({
  currentPage,
  totalPages,
  onPageChange,
  previousLabel = "Previous",
  nextLabel = "Next",
  sx,
  buttonSx,
}) => {
  const safeTotalPages = Math.max(1, Number(totalPages) || 1);
  const visiblePages = getVisiblePages(currentPage, safeTotalPages);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 1,
        mt: 4,
        flexWrap: "wrap",
        ...sx,
      }}
    >
      <Button
        variant="contained"
        color="secondary"
        disabled={currentPage <= 1}
        onClick={() => onPageChange(Math.max(Number(currentPage || 1) - 1, 1))}
        sx={buttonSx}
      >
        {previousLabel}
      </Button>

      {visiblePages.map((page, idx) =>
        page === "..." ? (
          <Typography key={`ellipsis-${idx}`} variant="body2" sx={{ px: 1 }}>
            ...
          </Typography>
        ) : (
          <Button
            key={page}
            variant={page === currentPage ? "contained" : "outlined"}
            color={page === currentPage ? "primary" : "inherit"}
            onClick={() => onPageChange(page)}
            sx={{ minWidth: 40, px: 1.5, ...buttonSx }}
          >
            {page}
          </Button>
        )
      )}

      <Button
        variant="contained"
        color="secondary"
        disabled={currentPage >= safeTotalPages}
        onClick={() => onPageChange(Math.min(Number(currentPage || 1) + 1, safeTotalPages))}
        sx={buttonSx}
      >
        {nextLabel}
      </Button>
    </Box>
  );
};

export default PaginationControls;
